module.exports = __webpack_public_path__ + "img/text.45325810.png";